import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M38 20C38 20.7615 37.3769 21.3846 36.6154 21.3846H3.38462C2.61927 21.3846 2 20.7658 2 20.0008C2 19.2384 2.61962 18.6154 3.38462 18.6154H36.6154C37.3769 18.6154 38 19.2384 38 20Z" })
});
export default SvgMinus;
